<template>
  <div class="shopinfo-box">
    <a-card :bordered="false">
      <div class="shopinfo-content">
        <a-row>
          <a-col :span="2">
            <span class="title">文章标题</span>
          </a-col>
          <a-col :span="22">
            <a-input placeholder="请输入标题" v-model="title" />
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="2">
            <span class="title">排序</span>
          </a-col>
          <a-col :span="4">
            <a-input placeholder="请输入0-99" v-model="sort" />
          </a-col>
          <a-col :span="2" offset="1">
            <span class="title">分类</span>
          </a-col>
          <a-col :span="4">
            <a-select defaultValue="1" style="width: 120px" v-model="subType">
              <a-select-option
                v-for="item in articleType"
                :key="item.id"
                :value="item.id"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </a-col>
        </a-row>
        <a-row>
          <quill-editor
            v-model="content"
            ref="myQuillEditor"
            :options="editorOption"
          ></quill-editor>
        </a-row>
        <a-row>
          <div class="btn-box">
            <a-button type="primary" @click="sub">{{ btnTxt }}</a-button>
          </div>
        </a-row>
      </div>
    </a-card>
  </div>
</template>

<script>
import { Article_add, Article_detail, Article_update } from "@/api/article";
import { SETTING_query } from "@/api/setting";
export default {
  data() {
    return {
      siteInfo: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      form: {
        desc: ""
      },
      title: "",
      content: "",
      editorOption: {},
      startTime: "",
      articleType: [],
      subType: "1",
      startus: "public",
      btnTxt: "提交",
      sort: 50,
      type: "add"
    };
  },
  created() {},
  mounted() {
    console.log(this.$route.params.id);
    this.getInfo({ type: "articletype" });
    if (this.$route.params.id) {
      this.getDetail({ id: this.$route.params.id });
    }
  },
  methods: {
    getInfo: function(_obj) {
      SETTING_query(_obj)
        .then(response => {
          this.articleType = response.res;
        })
        .catch(() => {});
    },
    getDetail: function(_obj) {
      Article_detail(_obj)
        .then(response => {
          console.log(response.res);
          this.content = decodeURIComponent(response.res.article_content);
          this.title = response.res.article_title;
          this.btnTxt = "保存修改";
          this.type = "update";
        })
        .catch(() => {});
    },
    sub: function() {
      if (!this.title) {
        this.$notification.error({
          message: "提示",
          description: "请输入标题"
        });
        return;
      }
      if (!this.content) {
        this.$notification.error({
          message: "提示",
          description: "请输入内容"
        });
        return;
      }
      if (this.type === "add") {
        Article_add({
          title: this.title,
          sort: Number(this.sort),
          type: this.subType,
          content: encodeURIComponent(this.content)
        })
          .then(response => {
            console.log(response.res);
            if (response.status === 0) {
              this.$notification.success({
                message: "提示",
                description: response.res
              });
              this.title = "";
              this.content = "";
            } else {
              this.$notification.success({
                message: "提示",
                description: response.res
              });
            }
          })
          .catch(() => {});
      } else if (this.type === "update") {
        // this.content = this.encode(this.content);
        let _obj = {
          id: this.$route.params.id,
          title: this.title,
          sort: Number(this.sort),
          type: this.subType,
          content: encodeURIComponent(this.content)
        };
        console.log(_obj);
        Article_update(_obj)
          .then(response => {
            console.log(response.res);
            if (response.status === 0) {
              this.$notification.success({
                message: "提示",
                description: response.res
              });
              this.title = "";
              this.content = "";
              this.type = "add";
              this.btnTxt = "提交";
            } else {
              this.$notification.success({
                message: "提示",
                description: response.res
              });
            }
          })
          .catch(() => {});
      }
    }
  }
};
</script>

<style lang="less" scoped>
.shopinfo-content {
  .ant-row {
    margin-bottom: 10px;
  }
  .title {
    display: block;
    line-height: 32px;
    box-sizing: border-box;
    padding-right: 10px;
    text-align-last: justify;
  }
  .btn-box {
    display: block;
    text-align: right;
  }
  form textarea.ant-input {
    min-height: 500px;
  }
}
</style>
